var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C1.46957 0 0.960859 0.206137 0.585786 0.573064C0.210714 0.939991 0 1.43765 0 1.95656L0 9.78282C0 10.3017 0.210714 10.7994 0.585786 11.1663C0.960859 11.5332 1.46957 11.7394 2 11.7394H4.5C4.65525 11.7394 4.80836 11.7747 4.94721 11.8427C5.08607 11.9106 5.20685 12.0092 5.3 12.1307L7.2 14.6087C7.29315 14.7302 7.41393 14.8288 7.55279 14.8967C7.69164 14.9646 7.84475 15 8 15C8.15524 15 8.30836 14.9646 8.44721 14.8967C8.58607 14.8288 8.70685 14.7302 8.8 14.6087L10.7 12.1307C10.7931 12.0092 10.9139 11.9106 11.0528 11.8427C11.1916 11.7747 11.3448 11.7394 11.5 11.7394H14C14.5304 11.7394 15.0391 11.5332 15.4142 11.1663C15.7893 10.7994 16 10.3017 16 9.78282V1.95656C16 1.43765 15.7893 0.939991 15.4142 0.573064C15.0391 0.206137 14.5304 0 14 0L2 0Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.2f3c8155f46d28807b688c9cf4f9db5c.svg";
export { ForwardRef as ReactComponent };